import { captureException, withScope } from '@sentry/browser';
import sanitizeRawContent from './sanitize';

/**
 * Captures an exception with an isolated scope and sanitized context data.
 * @param error - The actual error object caught in the catch block
 * @param contextName - A label for the data (e.g., 'failed_json_payload')
 * @param rawData - The data you want to debug with (will be sanitized)
 * @param tags - Optional: Specific tags for searching (e.g., { feature: 'checkout' })
 */
export default function captureSafeException(
    error: unknown,
    contextName: string,
    rawData: unknown,
    tags?: Record<string, string>
): void {
    withScope((scope) => {
        const safeData = sanitizeRawContent(rawData);
        scope.setExtra(contextName, safeData);

        if (tags) {
            Object.entries(tags).forEach(([key, value]) => {
                scope.setTag(key, value);
            });
        }

        captureException(error);
    });
}
